import { FieldPattern } from '..';

import { SEARCHABLE_DROPDOWN } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import DependentField from '../DependentField';

class SearchableDropdownField extends DependentField {
  readonly type: string = SEARCHABLE_DROPDOWN;

  readonly relevantDependentField: string;

  readonly options: Record<string, string[]>;

  mobilePlaceholder: string;

  constructor(searchableDropdownFieldData: FormFieldsType, initialValue = '') {
    super(searchableDropdownFieldData, initialValue);
    this.relevantDependentField =
      searchableDropdownFieldData.relevantDependentField ?? '';
    const rawOptions = searchableDropdownFieldData.options;
    this.options =
      rawOptions &&
        typeof rawOptions === 'object' &&
        !Array.isArray(rawOptions)
        ? (rawOptions as Record<string, string[]>)
        : {};
    this.mobilePlaceholder =
      searchableDropdownFieldData.mobile_placeholder ?? '';
  }

  match<T>(p: FieldPattern<T>): T {
    return p.SearchableDropdownField(this);
  }
}

export default SearchableDropdownField;
